import { Button, Form, Input, Select, Tooltip } from "antd";
import { Loading } from "components/Loading";
import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  departmentsActions,
  selectDepartments,
  selectLoadingGetDepartment,
  selectLoadingPostDepartment,
  selectTokenLogin,
} from "./slice";
import "./styles.scss";

export default function AddPage() {
  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const token = useSelector(selectTokenLogin);
  const listDepartment = useSelector(selectDepartments);
  const listGetDepartment = useSelector(selectLoadingGetDepartment);
  const listPostDepartment = useSelector(selectLoadingPostDepartment);

  useEffect(() => {
    if (token) {
      dispatch(departmentsActions.getDepartmentStarted());
    }
  }, [dispatch, token]);

  const [departmentSelect, setDepartmentSelect] = useState<number | null>(null);

  const handleSelectDepartment = useCallback((value: string) => {
    setDepartmentSelect(Number(value));
  }, []);

  const handleClearDepartment = useCallback(() => {
    setDepartmentSelect(null);
  }, []);

  const onFinish = useCallback(
    (value: any) => {
      dispatch(
        departmentsActions.postDepartmentStarted({
          department_id: value.department_id,
          department_level2_id: value.department_level2_id,
          link: value.link.trim(),
          page_name: value.page_name.trim(),
        })
      );
    },

    [dispatch]
  );
  if (listGetDepartment || !token) return <Loading />;

  return (
    <div className="add-page">
      <Form form={form} onFinish={onFinish} className="form-add-page">
        <Form.Item
          name="department_id"
          label="Phòng ban quản lý"
          className="form-add-page-item"
          rules={[{ required: true, message: "Vui lòng chọn phòng ban" }]}
        >
          <Select
            allowClear
            placeholder="Chọn phòng ban"
            onSelect={handleSelectDepartment}
            onClear={handleClearDepartment}
          >
            {listDepartment?.map((department, idx) => (
              <Select.Option key={idx} value={department.id}>
                {department.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="department_level2_id"
          label="Shop/Bộ phận/Vùng"
          className="form-add-page-item"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn phòng Shop/Bộ phận/Vùng",
            },
          ]}
        >
          {departmentSelect ? (
            <Select allowClear placeholder="Chọn Shop/Bộ phận/Vùng">
              {listDepartment
                ?.find((department) => department.id === departmentSelect)
                ?.checking_departments_level2_dto?.map((department_level2) => (
                  <Select.Option
                    key={department_level2.id}
                    value={department_level2.id}
                  >
                    {department_level2.name}
                  </Select.Option>
                ))}
            </Select>
          ) : (
            <Tooltip title="Vui lòng chọn phòng ban" color="#faad14">
              <Select placeholder="Chọn Shop/Bộ phận/Vùng" disabled />
            </Tooltip>
          )}
        </Form.Item>

        <Form.Item
          name="link"
          label="Link"
          className="form-add-page-item"
          rules={[
            {
              required: true,
              whitespace: true,
              message: "Vui lòng nhập link page facebook của bạn",
            },
            { max: 1000, message: "Link không được vượt quá 1000 ký tự" },
          ]}
        >
          <Input placeholder="Dán đường link của bạn vào đây" />
        </Form.Item>

        <Form.Item
          name="page_name"
          label="Tên page/group"
          className="form-add-page-item"
          rules={[
            {
              required: true,
              whitespace: true,
              message: "Vui lòng nhập tên page facebook của bạn",
            },
            { max: 255, message: "Tên page không được vượt quá 255 ký tự" },
          ]}
        >
          <Input placeholder="Nhập tên Page/Group" />
        </Form.Item>

        <div className="form-add-page-btn">
          <Button type="primary" htmlType="submit" loading={listPostDepartment}>
            Thêm
          </Button>
        </div>
      </Form>
    </div>
  );
}
